import { createBrowserHistory } from 'history';

let history;
if (typeof document !== 'undefined') {
    history = createBrowserHistory({
        /* pass a configuration object here if needed */
    });
}

export default history;